import React from 'react';
import { Column, Copy, IColumnProps } from '@grubhubprod/gh-cookbook-react';

export type DataTableColumnProps = Omit<IColumnProps, 'gutter'>;

export const DataTableColumn: React.FC<DataTableColumnProps> = ({
  children,
  ...rest
}) => (
  <Column {...rest} gutter={12}>
    <Copy variant="body" color="secondaryText">
      {children}
    </Copy>
  </Column>
);
